import { ClassEnum } from '@/constants/enum';
import styled from 'styled-components';

export const OnboardStyled = styled.div`
  .${ClassEnum.CalendarDay} {
    width: 3em;
    height: 3em;
  }

  #dd-calendar {
    margin-top: 5px;
  }

  #dd-label {
    margin-top: 4px;
    margin-bottom: -8px;
  }

  .${ClassEnum.PickupLabel}, .${ClassEnum.DeliveryLabel}, .${ClassEnum.Header} {
    margin-top: 4px;
  }

  .${ClassEnum.HeaderRadioLabel}.checked {
    background: #f889a8 !important;
  }

  .ot-dingdoong-header__radio-label:hover:not(.checked) {
    background: #fabdcc !important;
  }

  .${ClassEnum.HeaderRadioLabelText} {
    white-space: nowrap;
  }
`;

export const SelectStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  label {
    > span {
      font-size: 16px;
    }
  }
  .Polaris-Select__Content {
    font-size: 16px;
  }
  .Polaris-Labelled__HelpText {
    > span {
      font-size: 14px;
    }
  }
`;
